/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Output_PortInputs */

const cs_workflow_output_port = /** @type {(inputs: Workflow_Output_PortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výstupní port`)
};

const en_workflow_output_port = /** @type {(inputs: Workflow_Output_PortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Output port`)
};

/**
* | output |
* | --- |
* | "Output port" |
*
* @param {Workflow_Output_PortInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_output_port = /** @type {((inputs?: Workflow_Output_PortInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Output_PortInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_output_port(inputs)
	return cs_workflow_output_port(inputs)
});